import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 55 55' fill={fillColor} className={className}>
      <g>
        <rect fill='none' id='canvas_background' height='57' width='57' y='-1' x='-1' />
      </g>
      <g>
        <path
          stroke='null'
          d='m9.305371,18.797441c4.710695,0 8.542711,-3.76104 8.542711,-8.384483s-3.832016,-8.384483 -8.542711,-8.384483s-8.542711,3.76104 -8.542711,8.384483s3.832016,8.384483 8.542711,8.384483zm0,-14.3734c3.364608,0 6.101936,2.686628 6.101936,5.988917s-2.737329,5.988917 -6.101936,5.988917s-6.101936,-2.686628 -6.101936,-5.988917s2.737329,-5.988917 6.101936,-5.988917z'
        />
        <rect y='9.927194' x='20.768967' width='31' height='2' />
        <path d='m8.870247,35.876554c3.86,0 7,-3.14 7,-7s-3.14,-7 -7,-7s-7,3.14 -7,7s3.14,7 7,7zm0,-12c2.757,0 5,2.243 5,5s-2.243,5 -5,5s-5,-2.243 -5,-5s2.243,-5 5,-5z' />
        <rect y='28.667687' x='20.768967' width='31' height='2' />
        <path d='m8.870247,53.193007c3.86,0 7,-3.14 7,-7s-3.14,-7 -7,-7s-7,3.14 -7,7s3.14,7 7,7zm0,-12c2.757,0 5,2.243 5,5s-2.243,5 -5,5s-5,-2.243 -5,-5s2.243,-5 5,-5z' />
        <rect y='45.588574' x='21.006307' width='31' height='2' />
        <rect
          stroke='null'
          transform='rotate(-38.34329605102539 13.371058464050291,8.387377738952637) '
          y='6.648383'
          x='6.398717'
          width='13.944683'
          height='3.477987'
        />
        <rect
          stroke='null'
          transform='rotate(-141.20184326171875 7.413259506225584,10.31632041931152) '
          y='8.459713'
          x='3.75144'
          width='7.32364'
          height='3.713215'
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
